export const Create = () => import("./Create.vue");
export const CreateSubMenu = () => import("./CreateSubMenu.vue");
export const Edit = () => import("./Edit.vue");
export const List = () => import("./List.vue");
export const SubMenuList = () => import("./SubMenuList.vue");
export const LinkUsers = () => import("./LinkUsers.vue");
